import request from './request'

let resolved = false

/**
 * 防封双层域名：页面首次加载时检查当前域名。
 * 若访问的是分享域(A)且配置了落地域(B)，立即跳转到B（路径参数保持不变）。
 * 同时缓存分享域，供后台各处拼接链接使用。
 */
export async function checkDomainRedirect() {
  if (resolved) return
  resolved = true
  try {
    const data = await request.get('/domain/public/resolve', { params: { host: window.location.host } })
    if (data && data.shareDomain) window.__shareDomain = data.shareDomain
    if (data && data.redirect && data.target) {
      const url = window.location.protocol + '//' + data.target + window.location.pathname + window.location.search + window.location.hash
      window.location.replace(url)
    }
  } catch (e) {
    // 解析失败不影响正常访问
  }
}

/** 拼链接用的域名前缀：配置了分享域(A)用A，否则用当前域名 */
export function shareOrigin() {
  return window.__shareDomain
    ? window.location.protocol + '//' + window.__shareDomain
    : window.location.origin
}
